<template>
    <div class="input-box">
        <div class="input-content" @keydown="keydown" @keyup="keyup" @paste="paste" @mousewheel="mousewheel"
                @input="inputEvent">
            <input max="9" min="0" maxlength="1" data-index="0" v-model.trim.number="otpCodeMem[0]"  ref="firstinput"/>
            <input max="9" min="0" maxlength="1" data-index="1" v-model.trim.number="otpCodeMem[1]" />
            <input max="9" min="0" maxlength="1" data-index="2" v-model.trim.number="otpCodeMem[2]" />
            <input max="9" min="0" maxlength="1" data-index="3" v-model.trim.number="otpCodeMem[3]" />
            <input max="9" min="0" maxlength="1" data-index="4" v-model.trim.number="otpCodeMem[4]" />
            <input max="9" min="0" maxlength="1" data-index="5" v-model.trim.number="otpCodeMem[5]" />
            <img v-if="!isShow" @click="toggleMask" src="@/assets/pc/Icon - Unmask@3x.png" />
            <img v-if="isShow" @click="toggleMask" src="@/assets/pc/mask-outline.svg" />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Code',
        data() {
            return {
                pasteResult: [],
                otpCode: [
                    '',
                    '',
                    '',
                    '',
                    '',
                    ''
                ],
                isShow: true,
            };
        },
        props: {
            code: {
                type: String,
                default: ''
            }
        },
        computed: {
            input() {
                if (this.code && Array.isArray(this.code) && this.code.length === 6) {
                    return this.code;
                } else if (/^\d{6}$/.test(this.code.toString())) {
                    return this.code.toString().split('');
                } else if (this.pasteResult.length === 6) {
                    return this.pasteResult;
                } else {
                    return new Array(6);
                }
            },
            otpCodeMem() {
                if (this.isShow) {
                    return this.otpCode.map(val => val != '' ? '*' : '')
                } else {
                    return this.otpCode
                }
            }
        },
        watch: {
            otpCode: {
                handler: function (val) {
                    this.$emit('otpCode', val)
                },
                deep: true
            }
        },
        methods: {
            toggleMask () {
                this.isShow = !this.isShow;
            },
            // 解决一个输入框输入多个字符
            inputEvent(e) {
                var index = e.target.dataset.index * 1;
                if (!e.shiftKey && (e.keyCode >= 48 && e.keyCode <=57 || e.keyCode >= 65 && e.keyCode <=90 || e.keyCode >= 96 && e.keyCode <=105)) {
                    // 必须在这里符直，否则输入框会是空值
                    this.$set(this.otpCode, index, e.key);
                }
            },
            keydown(e) {
                var index = e.target.dataset.index * 1;
                var el = e.target;
                if (e.key === 'Backspace') {
                    if (this.otpCode[index].length > 0) {
                        this.$set(this.otpCode, index, '')
                    } else {
                        if (el.previousElementSibling) {
                            el.previousElementSibling.focus()
                            this.$set(this.otpCode, index - 1, '')
                        }
                    }
                } else if (e.key === 'Delete') {
                    if (this.otpCode[index].length > 0) {
                        this.$set(this.otpCode, index, '')
                    } else {
                        if (el.nextElementSibling) {
                            this.$set(this.otpCode, index = 1, '')
                        }
                    }
                    if (el.nextElementSibling) {
                        el.nextElementSibling.focus()
                    }
                } else if (e.key === 'Home') {
                    el.parentElement.children[0] && el.parentElement.children[0].focus()
                } else if (e.key === 'End') {
                    el.parentElement.children[this.otpCode.length - 1] && el.parentElement.children[this.otpCode.length - 1].focus()
                } else if (e.key === 'ArrowLeft') {
                    if (el.previousElementSibling) {
                        el.previousElementSibling.focus()
                    }
                } else if (e.key === 'ArrowRight') {
                    if (el.nextElementSibling) {
                        el.nextElementSibling.focus()
                    }
                } else if (e.key === 'ArrowUp') {
                    if (this.otpCode[index] * 1 < 9) {
                        this.$set(this.otpCode, index, (this.otpCode[index] * 1 + 1).toString());
                    }
                } else if (e.key === 'ArrowDown') {
                    if (this.otpCode[index] * 1 > 0) {
                        this.$set(this.otpCode, index, (this.otpCode[index] * 1 - 1).toString());
                    }
                }
            },
            keyup(e) {
                var index = e.target.dataset.index * 1;
                var el = e.target;
                // 解决输入e的问题
                el.value = el.value.replace(/Digit|Numpad|Key/i, '').replace(/1/g, '').slice(0, 1);
                if (!e.shiftKey && (e.keyCode >= 48 && e.keyCode <=57 || e.keyCode >= 65 && e.keyCode <=90 || e.keyCode >= 96 && e.keyCode <=105)) {
                    // 必须在这里符直，否则输入框会是空值
                    this.$set(this.otpCode, index, e.key);
                    el.nextElementSibling && el.nextElementSibling.focus();
                    if (index === 5) {
                        if (this.otpCode.join('').length === 6) {
                            document.activeElement.blur();
                            this.$emit('complete', this.otpCode);
                        }
                    }
                } else {
                    if (this.otpCode[index] === '') {
                        this.$set(this.otpCode, index, '');
                    }
                }
            },
            mousewheel(e) {
                var index = e.target.dataset.index;
                if (e.wheelDelta > 0) {
                    if (this.otpCode[index] * 1 < 9) {
                        this.$set(this.otpCode, index, (this.otpCode[index] * 1 + 1).toString());
                    }
                } else if (e.wheelDelta < 0) {
                    if (this.otpCode[index] * 1 > 0) {
                        this.$set(this.otpCode, index, (this.otpCode[index] * 1 - 1).toString());
                    }
                } else if (e.key === 'Enter') {
                    if (this.otpCode.join('').length === 6) {
                        document.activeElement.blur();
                        this.$emit('complete', this.otpCode);
                    }
                }
            },
            paste(e) {
                // 当进行粘贴时
                e.clipboardData.items[0].getAsString(str => {
                    if (str.toString().length === 6) {
                        this.pasteResult = str.split('');
                        document.activeElement.blur();
                        this.$emit('complete', this.otpCode);
                        this.pasteResult = [];
                    } else {
                        // 如果粘贴内容不合规，清除所有内容
                        this.otpCode[0] = new Array(6)
                    }
                })
            }
        },
        mounted() {
            // 等待dom渲染完成，在执行focus,否则无法获取到焦点
            this.$nextTick(() => {
                this.$refs.firstinput.focus()
            })
        },
    }
</script>

<style scoped lang="scss">
.input-box {
    .input-content {
        margin: 32px 0 0;
        display: flex;
        width: 100%;
        height: 60px;
        justify-content: space-between;
        align-items: center;
        input {
            width: 42px;
            height: 100%;
            border: 1px solid #99C1E7;
            border-radius: 8px;
            font-size: 45px;
            text-align: center;
            color: #919191;
        }
        img {
            width: 24px;
            height: 24px;
            cursor: pointer;
        }
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        appearance: none;
        margin: 0;
    }
}
</style>